import React from 'react';

const Sept24_2008Page = () => {
  return (
    <div className="page-container-wrapper max-width-default padding-default">
      <div className="page-header">
        <h1>
          <i className="fas fa-flag-usa"></i>
          September 24, 2008 - The American Dream
        </h1>
        <p>Stories of hope, perseverance, and the pursuit of the American Dream.</p>
      </div>

      <div className="page-content">
        <div className="section">
          <div className="american-dream-content">
            <p className="welcome-text">
              September 24, 2008 represents a significant moment in our family's journey
              toward achieving the American Dream. This is a story of determination,
              hard work, and the belief that anything is possible in America.
            </p>

            <div className="story-section">
              <h3>Our American Dream Story</h3>
              <p>
                Like so many families who came to America seeking better opportunities,
                our story is one of sacrifice, hope, and unwavering determination.
                September 24, 2008 marked a pivotal moment in that journey.
              </p>
              
              <p>
                The American Dream isn't just about financial success - it's about
                the freedom to pursue your passions, provide for your family, and
                build something meaningful for future generations.
              </p>

              <div className="dream-values">
                <h4>What the American Dream Means to Us:</h4>
                <ul>
                  <li>The opportunity to build a better life through hard work</li>
                  <li>Freedom to pursue our goals and aspirations</li>
                  <li>The ability to provide for our family and community</li>
                  <li>Preserving our heritage while embracing new opportunities</li>
                  <li>Creating a legacy for future generations</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sept24_2008Page;